/* eslint-disable react/no-array-index-key */
import React, { useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import YouTubeIcon from '@material-ui/icons/YouTube'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Button from '@material-ui/core/Button'
import { FaSkullCrossbones } from 'react-icons/fa'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  inline: {
    display: 'inline',
  },
}))

const ListHeaterComments = (props) => {
  const { heater } = props
  const [open, setOpen] = useState({})
  const anchorRef = useRef(null)
  const classes = useStyles()

  const handleClick = (index) => {
    setOpen({ [index]: !open[index] })
  }
  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
    >
      {Array.isArray(heater.heater) &&
        heater.heater.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem id={item.id} key={item.id}>
                <ListItemIcon>
                  <FaSkullCrossbones size="25" />
                </ListItemIcon>
                <ListItemText
                  primary={item.autor[0].authorDisplayName}
                  secondary={
                    <>
                      <Typography
                        component="span"
                        variant="body2"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        Like: {item.autor[0].likes.toFixed(2)} - Magnitud:{' '}
                        {item.autor[0].magnitude.toFixed(2)} - Score:{' '}
                        {item.autor[0].score.toFixed(2)}
                        <br />
                        <strong>Nivel de Hate: {item.count} </strong>
                      </Typography>
                      <br />
                      {`Comentario: ${item.autor[0].comentario}`}
                    </>
                  }
                />
                <ListItemSecondaryAction>
                  <a
                    target="blank"
                    href={`https://www.youtube.com/watch?v=${item.autor[0].videoId}`}
                  >
                    <IconButton edge="end" aria-label="comments">
                      <YouTubeIcon style={{ color: '#ff0000' }} />
                    </IconButton>
                  </a>
                  <IconButton
                    edge="end"
                    aria-label="Comentario "
                    onClick={() => handleClick(index)}
                  >
                    {open[index] ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </ListItemSecondaryAction>
                {item.autor.length >= 2 && (
                  <Collapse
                    ref={anchorRef[index]}
                    in={open[index]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      component="div"
                      fire
                      disablePadding
                      className={classes.root}
                      subheader={
                        <Button
                          onClick={() => handleClick(index)}
                          variant="contained"
                        >
                          Cerrar
                        </Button>
                      }
                    >
                      {item.autor.map((text, i) => (
                          <React.Fragment key={i}>
                            <ListItem button onClick={() => handleClick(index)}>
                              <ListItemText
                                secondary={
                                  <>
                                    <Typography
                                      component="span"
                                      variant="body2"
                                      color="textPrimary"
                                    >
                                      Like: {text.likes.toFixed(2)} - Magnitud:{' '}
                                      {text.magnitude.toFixed(2)} - Score:{' '}
                                      {text.score.toFixed(2)}
                                    </Typography>
                                    <br />
                                    {`Comentario: ${text.comentario}`}
                                  </>
                                }
                              />
                              <ListItemSecondaryAction>
                                <a
                                  target="blank"
                                  href={`https://www.youtube.com/watch?v=${text.videoId}`}
                                >
                                  <IconButton edge="end" aria-label="comments">
                                    <YouTubeIcon style={{ color: '#ff0000' }} />
                                  </IconButton>
                                </a>
                              </ListItemSecondaryAction>
                            </ListItem>
                          </React.Fragment>
                        ))}
                    </List>
                  </Collapse>
                )}
              </ListItem>
            </React.Fragment>
          ))}
    </List>
  )
}

export default ListHeaterComments